export const nirFormat = [
  { char: /\d/, repeat: 1 },
  { exactly: ' ' },
  { char: /\d/, repeat: 2 },
  { exactly: ' ' },
  { char: /\d/, repeat: 2 },
  { exactly: ' ' },
  { char: /[A-Za-z0-9]/, repeat: 2 },
  { exactly: ' ' },
  { char: /\d/, repeat: 3 },
  { exactly: ' ' },
  { char: /\d/, repeat: 3 },
  { exactly: ' ' },
  { char: /\d/, repeat: 2 }
];

export const localPhoneFormat = [
  { char: /\d/, repeat: 2 },
  { exactly: ' ' },
  { char: /\d/, repeat: 2 },
  { exactly: ' ' },
  { char: /\d/, repeat: 2 },
  { exactly: ' ' },
  { char: /\d/, repeat: 2 },
  { exactly: ' ' },
  { char: /\d/, repeat: 2 }
];

export const prefixedPhoneFormat = [
  { char: /\+/, repeat: 1 },
  { char: /\d/, repeat: 1 },
  { char: /\d/, repeat: 1 },
  { exactly: ' ' },
  { char: /\d/, repeat: 1 },
  { exactly: ' ' },
  { char: /\d/, repeat: 2 },
  { exactly: ' ' },
  { char: /\d/, repeat: 2 },
  { exactly: ' ' },
  { char: /\d/, repeat: 2 },
  { exactly: ' ' },
  { char: /\d/, repeat: 2 }
];

export const unilabsHome =
  process.env.REACT_APP_MY_UNILABS_BASE_URL || 'https://my-unilabs.fr';
